import React, { useState, lazy } from 'react';
import { Link } from 'react-router-dom';
import { ScrollSection } from '../components/About/ScrollSection';
import { Tabs, TabList, Tab, TabPanel } from '../components/UI/Tabs';
import { Button } from '../components/UI/Button';
import { ArrowRightIcon, ArrowRight } from 'lucide-react';
export const About = () => {
  const [activeTab, setActiveTab] = useState('vision');
  const teamMembers = [{
    id: 'andrew-igbineweka',
    name: 'Andrew Igbineweka',
    role: 'Founder',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2e91tcJdXJukNhGR3YoR4c/Andrew_Igbineweka%2C_Founder_.jpg',
    brief: "Andrew moves through the world with the steadiness of someone who understands that ideas only matter when they are built into systems that change people's lives. As a Learning Experience Designer and Digital Learning Strategist, he has spent more than seven years building learning ecosystems that help individuals and organizations adapt to a world increasingly defined by AI and digital innovation."
  }, {
    id: 'precious-obayuwana',
    name: 'Precious Obayuwana',
    role: 'Chief Operations Officer',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tiuzezKDFtcTj9dbiEA2Tq/Precious_Obayuwana%2C_Chief_Operations_Officer.jpg',
    brief: 'Precious brings a rare kind of operational clarity—the kind that steadies an organization, sharpens its rhythm, and turns vision into grounded, repeatable excellence. Her work sits at the heart of systems, people, and purpose, yet her impact is felt in the quiet confidence she brings into every room: things will work, people will grow, and the mission will move.'
  }, {
    id: 'bibi-eneje',
    name: 'Bibi Eneje',
    role: 'Chief Growth Officer',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7u76HdqRGggPRPNySjG8aG/Bibi_Eneje%2C_Chief_Growth_Officer.png',
    brief: 'Bibi enters a room the way a catalyst enters a reaction—subtle at first, then quietly transformative. Her work sits at the crossroads of storytelling, culture shaping, and strategic influence, and she carries the rare ability to turn scattered potential into structured momentum. Growth, in her hands, is not a department. It is an ecosystem.'
  }, {
    id: 'bella-ojoka',
    name: 'Bella Ojoka',
    role: 'Programs and Community Lead',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vy2d386bQZ37DRZ67avafS/Bella_Ojoka%2C_Programs_and_Community_Lead.jpg',
    brief: "Bella carries a kind of steadiness that makes complex work feel possible. Her mind is analytical, her heart is people-centered, and her craft lives in the space where data, strategy, and human transformation meet. She is the kind of leader who doesn't just run programs—she architects experiences that move people forward."
  }, {
    id: 'george-ozigagu-topa',
    name: 'George Ozigagu Topa',
    role: 'Human Resources Lead',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7NPfEGqqSwbJWuP8w8bnhB/George_Ozigagu_Topa%2C_Human_Resources.jpg',
    brief: 'George is the kind of HR leader every growing ecosystem needs—measured, intuitive, and deeply committed to the science and soul of people. He understands that culture is not created by accident; it is engineered through clarity, trust, and the right talent in the right roles.'
  }, {
    id: 'maxwell-orioko',
    name: 'Maxwell Orioko',
    role: 'Content & Design Lead',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ted3p6u8tzPPN9kZoNtuEk/Maxwell_Orioko%2C_Content_and_Design_Lead.jpg',
    brief: 'Maxwell is the visual mind of the ecosystem—the one who turns ideas into identity, concepts into form, and strategy into imagery that lingers long after the room has emptied. His work threads together graphic design, digital storytelling, and AI-powered visual creation, giving The Networking Salon its unmistakable aesthetic rhythm: sharp, intentional, and deeply human.'
  }];
  return <div className="pt-20" data-id="element-1422" data-mp="15wa6w9d1vi70">
      <section className="py-16 bg-secondary/5" data-id="element-1423" data-mp="15wilc5otmvkb">
        <div className="container mx-auto px-4" data-id="element-1424" data-mp="r6ujn3cq9uw2">
          <h1 className="text-4xl md:text-5xl font-bold text-center text-secondary-dark mb-8" data-id="element-1425" data-mp="r3yjd8dequ4g">
            About The Networking Salon
          </h1>
          <p className="text-center text-lg text-secondary max-w-3xl mx-auto" data-id="element-1426" data-mp="1jvi97b4if6ff">
            Building communities that connect professionals to powerful
            networks, transformative ideas, and life-changing opportunities.
          </p>
        </div>
      </section>
      <div className="container mx-auto px-4 py-16" data-id="element-1427" data-mp="1ev415t2wrwhe">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-24" data-id="element-1428" data-mp="1etsyxxp42wse">
          <div className="order-2 lg:order-1" data-id="element-1429" data-mp="3vj868tmdjk44">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pmaGVbLENs5yRHebja1Kb2/3_Bibi.jpg" alt="Diverse people networking at The Networking Salon" className="w-full h-auto rounded-lg shadow-md grayscale" loading="lazy" style={{
            maxWidth: '100%'
          }} data-id="element-1430" data-mp="3g8ogcnto53h" />
          </div>
          <div className="order-1 lg:order-2" data-id="element-1431" data-mp="5sj6otmukixd">
            <h2 className="text-3xl font-bold mb-6 text-secondary-dark" data-id="element-1432" data-mp="wu4sjncupxw">
              About Us
            </h2>
            <p className="text-secondary text-lg" data-id="element-1433" data-mp="39c41tdce14yt">
              The Networking Salon is a high-trust, multi-city professional
              ecosystem that combines AI and digital skills training, authority
              building masterclasses, networking salons, opportunity matching,
              recruitment support, and peer collaboration across cities in
              Nigeria, Germany, and Namibia. We build close-knit, high-value
              communities that connect people to powerful networks,
              transformative ideas, and accessible opportunities that help them
              thrive in their careers, businesses, and impact initiatives.
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-24" data-id="element-1434" data-mp="3fa7iiliddv53">
          <div data-id="element-1435" data-mp="3k3s7jo1zjes5">
            <h2 className="text-3xl font-bold mb-6 text-secondary-dark" data-id="element-1436" data-mp="3k390519yo8sd">
              Why We Exist
            </h2>
            <p className="text-secondary text-lg" data-id="element-1437" data-mp="3p3oenw5zbmbx">
              Across Africa, many young professionals, entrepreneurs, and
              educators struggle with three connected problems: limited access
              to practical digital skills, weak and fragmented professional
              networks, and poor access to opportunities such as jobs,
              partnerships, funding, and mentorship.
            </p>
            <p className="text-secondary text-lg mt-4" data-id="element-1438" data-mp="glqqcoamorpb">
              Without intentional platforms, talent and ideas remain siloed.
              Promising leaders are left without the visibility, opportunities,
              or relationships they need to grow and scale their work.
            </p>
          </div>
          <div data-id="element-1439" data-mp="2139gndtwuy4f">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3oN7mV8GW4b1q39kgBjUNn/1755202597036.jpg" alt="Professionals facing isolation and fragmented networks" className="w-full h-auto rounded-lg shadow-md grayscale" loading="lazy" style={{
            maxWidth: '100%'
          }} data-id="element-1440" data-mp="214u98xwo06zn" />
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-24" data-id="element-1441" data-mp="1ibqd95vz5i1v">
          <div className="order-2 lg:order-1" data-id="element-1442" data-mp="1df9oc9gyaznq">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cMappWzpJqsfBegZChWrww/1755202597051.jpg" alt="Salon-style gatherings and collaborative sessions" className="w-full h-auto rounded-lg shadow-md grayscale" loading="lazy" style={{
            maxWidth: '100%'
          }} data-id="element-1443" data-mp="1dg1jxkajsxe0" />
          </div>
          <div className="order-1 lg:order-2" data-id="element-1444" data-mp="2bq56fkb431k5">
            <h2 className="text-3xl font-bold mb-6 text-secondary-dark" data-id="element-1445" data-mp="2glu8bualsujm">
              Our Solution
            </h2>
            <p className="text-secondary text-lg" data-id="element-1446" data-mp="22uz6h1yivdpj">
              The Networking Salon is more than a meetup — it's a high-trust,
              multi-city professional ecosystem. We combine AI and digital
              skills training, authority building masterclasses, networking
              salons, opportunity matching, recruitment support, and peer
              collaboration so members build trusted relationships, gain
              visibility, access curated opportunities (jobs, partnerships,
              funding, mentorship), and unlock their potential.
            </p>
            <p className="text-secondary text-lg mt-4" data-id="element-1447" data-mp="3ebp785k6fdbr">
              We've designed The Networking Salon as a layered ecosystem—free at
              the edges, valuable at the core, and transformative at the summit.
              Each level is a step closer to intentional growth, meaningful
              connection, and collaborative impact.
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-24" data-id="element-1448" data-mp="1geyy30k985be">
          <div data-id="element-1449" data-mp="1bngs1y3djejk">
            <h2 className="text-3xl font-bold mb-6 text-secondary-dark" data-id="element-1450" data-mp="1bmxm7fr00glw">
              Community Structure
            </h2>
            <div className="space-y-4" data-id="element-1451" data-mp="1qbbnhm8rnx0c">
              <div className="border-l-2 border-gray-300 pl-4" data-id="element-1452" data-mp="1lds7agsida5r">
                <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-1453" data-mp="1ldijmzuxrf38">
                  The Waiting Room
                </h3>
                <p className="text-gray-600" data-id="element-1454" data-mp="1uego1j9adomc">
                  An open, welcoming space for curious minds and aspiring
                  community members, providing free entry into our digital
                  ecosystem.
                </p>
              </div>
              <div className="border-l-2 border-gray-300 pl-4" data-id="element-1455" data-mp="20adxe5v87g">
                <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-1456" data-mp="3ce9d9psbsjkk">
                  Event Pathway
                </h3>
                <p className="text-gray-600" data-id="element-1457" data-mp="37e4xy335luvx">
                  Paid access through in-person participation, ideal for
                  professionals who thrive in face-to-face environments.
                </p>
              </div>
              <div className="border-l-2 border-gray-300 pl-4" data-id="element-1458" data-mp="2ygay4i66kj40">
                <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-1459" data-mp="3v37c30ykx5lo">
                  Inner Circle
                </h3>
                <p className="text-gray-600" data-id="element-1460" data-mp="3r3ozqtktq2ug">
                  Full community membership with access to masterclasses,
                  resources, and networking with coaches and business leaders.
                </p>
              </div>
              <div className="border-l-2 border-gray-300 pl-4" data-id="element-1461" data-mp="imtzllveuwk2">
                <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-1462" data-mp="ip6o6hvoc563">
                  Lifetime Partner Access
                </h3>
                <p className="text-gray-600" data-id="element-1463" data-mp="l7rxz11vyepb">
                  Strategic & personalized growth for entrepreneurs seeking deep
                  transformation and tailored support.
                </p>
              </div>
            </div>
          </div>
          <div data-id="element-1464" data-mp="v4egvkanivop">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gLvZ6fTjQSpPs86zUNEWZz/Group.jpg" alt="The Networking Salon community structure" className="w-full h-auto rounded-lg shadow-md grayscale" loading="lazy" style={{
            maxWidth: '100%'
          }} data-id="element-1465" data-mp="v7shamzr8uti" />
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" id="vision-mission-values" data-id="element-1466" data-mp="1dya8uo8upkda">
          <div data-id="element-1467" data-mp="1mxdu9yvhqbuy">
            <h2 className="text-3xl font-bold mb-6 text-secondary-dark" data-id="element-1468" data-mp="1mxnch0aaneq3">
              Our Vision, Mission & Core Values
            </h2>
            <div data-id="element-1469" data-mp="1rw8act22pmbd">
              <Tabs defaultTab="vision" className="mt-4" data-id="element-1470" data-mp="1rtm20r7cz2s3">
                <TabList data-id="element-1471" data-mp="3nzwl9tuhez1j">
                  <Tab id="vision" data-id="element-1472" data-mp="3nx0my4eq28ck">Vision</Tab>
                  <Tab id="mission" data-id="element-1473" data-mp="3jyaztk3vtcfq">Mission</Tab>
                  <Tab id="values" data-id="element-1474" data-mp="3jvf29wvy4prt">Values</Tab>
                </TabList>
                <TabPanel id="vision" data-id="element-1475" data-mp="1kaflo49vfem">
                  <div className="p-4 border border-gray-200 rounded-lg mt-4" data-id="element-1476" data-mp="1ld8u2p2htxp">
                    <h3 className="text-xl font-bold mb-2" data-id="element-1477" data-mp="3swv9jvrgsbrt">Our Vision</h3>
                    <p data-id="element-1478" data-mp="bgdgkqne17zz">
                      A world where every young professional and changemaker has
                      access to powerful networks, transformative ideas, and
                      life-changing opportunities — regardless of where they
                      start.
                    </p>
                  </div>
                </TabPanel>
                <TabPanel id="mission" data-id="element-1479" data-mp="2m9hnoakot4l5">
                  <div className="p-4 border border-gray-200 rounded-lg mt-4" data-id="element-1480" data-mp="2maj1unx02773">
                    <h3 className="text-xl font-bold mb-2" data-id="element-1481" data-mp="2hbg3fmbiyz83">Our Mission</h3>
                    <p data-id="element-1482" data-mp="wsvy6h83vm5z">
                      To build thriving, close-knit communities across 30 cities
                      by 2030 that connect professionals, mentors, and leaders
                      to people, ideas, and opportunities that help them grow,
                      lead, and thrive.
                    </p>
                  </div>
                </TabPanel>
                <TabPanel id="values" data-id="element-1483" data-mp="rzj965zildcp">
                  <div className="p-4 border border-gray-200 rounded-lg mt-4" data-id="element-1484" data-mp="e1uz7t6zjqmf">
                    <h3 className="text-xl font-bold mb-2" data-id="element-1485" data-mp="j0xvao4zmmi9">Core Values</h3>
                    <ul className="list-disc list-inside space-y-1" data-id="element-1486" data-mp="iz4o97qgq09q">
                      <li data-id="element-1487" data-mp="530v7hrbrxyu">Connection with Purpose</li>
                      <li data-id="element-1488" data-mp="92rs837g3abt">Opportunity for All</li>
                      <li data-id="element-1489" data-mp="93jnte11l823">Community over Competition</li>
                      <li data-id="element-1490" data-mp="1zexsvsgd202c">Excellence and Impact</li>
                      <li data-id="element-1491" data-mp="1zg8rzeyv2jn4">Global Mindset with Local Action</li>
                      <li data-id="element-1492" data-mp="23g16e8axrk0e">Trust and Respect</li>
                    </ul>
                  </div>
                </TabPanel>
              </Tabs>
            </div>
          </div>
          <div data-id="element-1493" data-mp="19rlb56f7dyuk">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gLvZ6fTjQSpPs86zUNEWZz/Group.jpg" alt="Global community of professionals and changemakers" className="w-full h-auto rounded-lg shadow-md grayscale" loading="lazy" style={{
            maxWidth: '100%'
          }} data-id="element-1494" data-mp="19r226f7j6kso" />
          </div>
        </div>
      </div>

      {/* The Team Section */}
      <section className="py-20 bg-gray-50 border-t border-gray-200" data-id="element-1495" data-mp="qyr3yyntnb0w">
        <div className="container mx-auto px-4" data-id="element-1496" data-mp="m2iwm7fv8m4a">
          <div className="text-center mb-14" data-id="element-1497" data-mp="h2o645005yjr">
            <h2 className="text-3xl md:text-4xl font-bold text-secondary-dark mb-4" data-id="element-1498" data-mp="h3z6duu8oo64">
              Meet The Team
            </h2>
            <p className="text-lg text-secondary max-w-2xl mx-auto" data-id="element-1499" data-mp="c5nw5j018bnd">
              The passionate people behind The Networking Salon — curators,
              trainers, and community builders dedicated to connecting
              professionals across the globe.
            </p>
          </div>

          <div className="max-w-6xl mx-auto space-y-16 mb-16" data-id="element-1500" data-mp="2np3os5m9d257">
            {teamMembers.map((member, index) => {
            const isEven = index % 2 === 0;
            return <div key={member.id} className={`grid grid-cols-1 lg:grid-cols-2 gap-8 items-center ${isEven ? '' : 'lg:grid-flow-dense'}`} data-id="element-1501" data-mp="2xokrqfa4l1xh" data-mpi={index}>
                  {/* Image */}
                  <div className={`${isEven ? '' : 'lg:col-start-2'} flex justify-center`} data-id="element-1502" data-mp="24y2n39tr6shy">
                    <div className="relative w-64 h-64 md:w-80 md:h-80" data-id="element-1503" data-mp="2eqqm8b87h8ju">
                      <div className="absolute inset-0 border-2 border-gray-300 rounded-full" data-id="element-1504" data-mp="1haukiznplxjm"></div>
                      <img src={member.image} alt={member.name} className="w-full h-full rounded-full object-cover grayscale hover:grayscale-0 transition-all duration-300" data-id="element-1505" data-mp="1m9xqqnffe9t6" />
                    </div>
                  </div>
                  {/* Content */}
                  <div className={`${isEven ? '' : 'lg:col-start-1 lg:row-start-1'} ${isEven ? 'lg:text-left' : 'lg:text-right'}`} data-id="element-1506" data-mp="1nxq4mnc05ax8">
                    <h3 className="text-3xl font-bold text-gray-800 mb-2" data-id="element-1507" data-mp="v9u9hn22zr2k">
                      {member.name}
                    </h3>
                    <p className="text-xl text-gray-600 font-medium mb-6" data-id="element-1508" data-mp="rad40tmnmtxe">
                      {member.role}
                    </p>
                    <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-1509" data-mp="109gmbvdzz5au">
                      {member.brief}
                    </p>
                    <Link to={`/team/${member.id}`} className={`inline-flex items-center gap-2 px-6 py-3 border-2 border-gray-800 rounded-md text-gray-800 font-medium hover:bg-gray-800 hover:text-white transition-colors duration-300 ${isEven ? '' : 'lg:flex-row-reverse'}`} data-id="element-1510" data-mp="2gmxe2hczvkx9">
                      <span data-id="element-1511" data-mp="2h8y29i3lvb1">Learn More</span>
                      <ArrowRight size={16} data-id="element-1512" data-mp="3km3ru6rlba2d" />
                    </Link>
                  </div>
                </div>;
          })}
          </div>

          {/* Join Team CTA */}
          <div className="max-w-3xl mx-auto text-center pt-12 border-t border-gray-200" data-id="element-1513" data-mp="h53r5r00q1on">
            <h3 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-1514" data-mp="l6fgrwiw6mwu">
              Join Our Team
            </h3>
            <p className="text-gray-600 mb-8" data-id="element-1515" data-mp="7fahivjfrwn1">
              We're always looking for passionate individuals to join our
              mission. Explore opportunities to contribute to our growing
              community.
            </p>
            <Link to="/join-team" className="inline-flex items-center justify-center px-6 py-3 border-2 border-gray-800 rounded-md text-gray-800 font-medium hover:bg-gray-800 hover:text-white transition-colors duration-300" data-id="element-1516" data-mp="102xvvsu45r18">
              View Open Positions
              <ArrowRight size={16} className="ml-2" data-id="element-1517" data-mp="2w62mx7dba5aq" />
            </Link>
          </div>
        </div>
      </section>
    </div>;
};